import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CheckBoxOptions, DropdownOptions, EnglishArabicDTO, FilterItem, FilterType, InputType, MultiLingualTextAreaOptions, MultiLingualTextBoxOptions, PagingOptions, TextAreaOptions, TextBoxOptions } from 'bnsights-control-library';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ClipboardService } from 'ngx-clipboard';
import { PageInfoService } from '../../../_metronic/core/services/page-info.service';
import { LookupModel } from '../../shared/models/Lookups/LookupModel';
import { LookupService } from '../../shared/Services/LookupService.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService, UtilityService, BBSFTranslateService, EnvironmentService } from 'bnsights-utilities-library';

@Component({
  selector: 'lib-lookup',
  templateUrl: './lookup.component.html'
})
export class LookupComponent implements OnInit {

  ApiUrl = "/api/admin/Lookup/"
  SubheaderTitle = this.utilityService.getResourceValue('Lookup');
  ShowToolbar = true;
  ShowbreadCrumb = false;
  LookupGroupsOptions: DropdownOptions;
  searchTextBox: TextBoxOptions;
  SelectedLookupList = [];
  LookupGroupsList = [];
  filterForm = new FormGroup({});
  LookupForm = new FormGroup({});
  showFilter: boolean = false;
  LookupPagingResult: any[] = [];
  LookupPaging: PagingOptions;
  LookupGroupFilter: FilterItem;
  TextInputFilter: FilterItem;
  IsFilterLoaded: boolean = false;
  ProductionMode: boolean = false;
  @ViewChild('LookupPagingViewElement', { static: false }) input: ElementRef;

  //Add Model Controls
  AddLookupForm = new FormGroup({});
  MultiLingualName:MultiLingualTextBoxOptions
  MultiLingualDescription:MultiLingualTextAreaOptions
  SysName: TextBoxOptions;
  LookupGroups: DropdownOptions;
  IsManageable: CheckBoxOptions;
  @ViewChild('CloseLookupModal', { static: false }) CloseLookupModal: ElementRef;
  
  //Edit Model Controls
  EditLookupForm = new FormGroup({});
  LookupId:number
  EditMultiLingualName:MultiLingualTextBoxOptions
  EditMultiLingualDescription:MultiLingualTextAreaOptions
  EditSysName: TextBoxOptions;
  EditLookupGroups: DropdownOptions;
  EditIsManageable: CheckBoxOptions;
  @ViewChild('CloseEditLookupModal', { static: false }) CloseEditLookupModal: ElementRef;

  //delete  Model Controls
  deletedLookupId: number = 0
  @ViewChild('CloseDeleteLookupModal', { static: false }) CloseDeleteLookupModal: ElementRef;

  //GenerateCode  Model Controls 
  GenerateCodeForm = new FormGroup({});
  GenerateCodeTextArea: TextAreaOptions;
  ValueToCopy: string = "";
  language:string="";
  // Decorator wires up blockUI instance
  @BlockUI() blockUI: NgBlockUI;
  ShowPageContent: boolean = false;

  constructor( private authService:AuthService,private pageInfoService:PageInfoService, public utilityService:UtilityService,private bbsfTranslateService:BBSFTranslateService,private environmentService:EnvironmentService,private _clipboardService: ClipboardService, private LookupService: LookupService, private modalService: NgbModal) {
  }
  async ngOnInit() {
    this.ShowPageContent=true;
    PageInfoService.PageTitle=this.utilityService.getResourceValue("Lookups")
    PageInfoService.PageBreadcrumbs=[
       {title: this.utilityService.getResourceValue("Home") , path: '/Admin/Home', isSeparator: false, isActive: false},
       {title: '', path: '', isSeparator: true, isActive: false}

    ];
    this.pageInfoService.calculateTitle();
    this.pageInfoService.calculateBreadcrumbs();
    this.bbsfTranslateService.onLangChange.subscribe((event)=>{
      this.language = event.lang;
      this.ngOnInit();
    })
    this.language = await this.utilityService.getCurrentLanguage();
    this.ProductionMode = this.environmentService.getProductionMode()
    this.LoadDropdownLists();
  }

  
  ReinitializeTemplatePaging() {
    let element = this.input as any;
    element.ReinitializePaging();
  }
  UpdateTemplatePaging() {
    let element = this.input as any;
    element.UpdatePaging();
  }
  setLookupListResult(result) {
    this.LookupPagingResult = result;
    this.ShowPageContent = true;
  }
  resetFilters() {
    this.LookupForm.controls["Type"].setValue([]);
    this.LookupForm.controls["searchTextBox"].setValue(null);
    let element = this.input as any;
    element.ReinitializePaging();

  }
  LoadDropdownLists() {
    this.LookupService.Loaddropdowns().subscribe((result) => {
      let DropdownLists = result as any
      this.LookupGroupsList=DropdownLists
     

      this.LookupGroupsOptions = new DropdownOptions();
      this.LookupGroupsOptions.Name = "Type"
      this.LookupGroupsOptions.LabelKey = "LookupGroups"
      this.LookupGroupsOptions.DataSource = this.LookupGroupsList
      this.LookupGroupsOptions.SingleSelection = false;
      this.LookupGroupsOptions.AllowSearchFilter = true;
      this.LookupGroupsOptions.Placeholder = "";

      // TextBox inti
      this.searchTextBox = new TextBoxOptions();
      this.searchTextBox.Name = "searchTextBox"
      this.searchTextBox.HideLabel = true;
      this.searchTextBox.Type = InputType.Text
      this.searchTextBox.Placeholder = this.utilityService.getResourceValue("SearchByName")

      this.LookupGroupFilter = new FilterItem();
      this.LookupGroupFilter.FormControlName = "Type"
      this.LookupGroupFilter.ActionParameterName = "LookupGroupId"
      this.LookupGroupFilter.IsFormControl = true
      this.LookupGroupFilter.FilterType = FilterType.DropdownList

      this.TextInputFilter = new FilterItem();
      this.TextInputFilter.FormControlName = "searchTextBox"
      this.TextInputFilter.ActionParameterName = "searchText"
      this.TextInputFilter.IsFormControl = true
      this.TextInputFilter.FilterType = FilterType.TextBox

      this.LookupPaging = new PagingOptions();
      this.LookupPaging.ActionPostURL = this.environmentService.getApiUrl() + this.ApiUrl + 'GetLookupsByFilter';
      this.LookupPaging.OnKeyPressFiltersControlNames = ["searchTextBox"]
      this.LookupPaging.DropdownFiltersControlNames = ["Type"];
      this.LookupPaging.Filters = [this.LookupGroupFilter, this.TextInputFilter]
      this.LookupPaging.ValidationToken = this.authService.authorizationHeaderValue()
      setTimeout(() => {
        this.IsFilterLoaded = true;
      }, 10);
    })
  }

  showAddLookupModal(AddLookupModal) {
    this,this.utilityService.startBlockUI();
    this.AddLookupForm = new FormGroup({});

    this.MultiLingualName = new MultiLingualTextBoxOptions();
    this.MultiLingualName.Name = "Name";
    this.MultiLingualName.ArabicLabelKey = "NameInArabic";
    this.MultiLingualName.EnglishLabelKey = "NameInEnglish";
    this.MultiLingualName.IsRequired = true;


    if (!this.ProductionMode) {
      this.SysName = new TextBoxOptions();
      this.SysName.Name = "SysName";
      this.SysName.LabelKey = "SysName";
      this.SysName.Type = InputType.Text;
      this.SysName.Value = null;
      this.SysName.IsRequired = false;


      this.IsManageable = new CheckBoxOptions();
      this.IsManageable.Name = "IsManageable"
      this.IsManageable.LabelKey = "Manageable"
      this.IsManageable.Value = true
    }

    this.MultiLingualDescription = new MultiLingualTextAreaOptions();
    this.MultiLingualDescription.Name = "Description";
    this.MultiLingualDescription.ArabicLabelKey =  "DescriptionInArabic";
    this.MultiLingualDescription.EnglishLabelKey = "DescriptionInEnglish";


    

    this.LookupGroups = new DropdownOptions();
    this.LookupGroups.Name = "LookupGroups"
    this.LookupGroups.LabelKey = "LookupGroups"
    this.LookupGroups.DataSource = this.LookupGroupsList
    this.LookupGroups.SingleSelection = true;
    this.LookupGroups.AllowSearchFilter = true;
    this.LookupGroups.Placeholder = "";

   

    this.modalService.open(AddLookupModal);
    this.utilityService.stopBlockUI();
  }
  addLookup() {
    if (this.AddLookupForm.invalid) {
      return;
    }
    else {
      
      let ResultModel = this.AddLookupForm.value;
       //console.log(ResultModel)
      let addModel = new LookupModel();
      addModel.Name.Arabic = ResultModel.Name.ArabicValue;
      addModel.Name.English = ResultModel.Name.EnglishValue;
      if (!this.ProductionMode) {
        addModel.SysName = ResultModel.SysName
      }
      addModel.Manageable = this.ProductionMode == true ? true : ResultModel.IsManageable;
      addModel.Description.English = ResultModel.Description.EnglishTextAreaValue;
      addModel.Description.Arabic = ResultModel.Description.ArabicTextAreaValue;
      addModel.LookupGroupID = ResultModel.LookupGroups!=null?Number(ResultModel.LookupGroups):null
       this.LookupService.AddLookup(addModel).subscribe((result) => {
         this.modalService.dismissAll();
        let element = this.input as any;
        element.ReinitializePaging();
      }, (error) => {
        
      })
    }
  }
  showEditLookupModal(Lookup: any, EditLookupModal) {

    this.utilityService.startBlockUI();
    this.EditLookupForm = new FormGroup({});

    this.LookupId = Lookup.id

    let Name=new EnglishArabicDTO();
    Name.Arabic=Lookup.name.arabic;
    Name.English=Lookup.name.english;

    this.EditMultiLingualName = new MultiLingualTextBoxOptions();
    this.EditMultiLingualName.Name = "EditName";
    this.EditMultiLingualName.ArabicLabelKey = "NameInArabic";
    this.EditMultiLingualName.EnglishLabelKey = "NameInEnglish";
    this.EditMultiLingualName.IsRequired = true;
    this.EditMultiLingualName.Value = Name;
    
    this.EditSysName = new TextBoxOptions();
    this.EditSysName.Name = "EditSysName";
    this.EditSysName.LabelKey = "SysName";
    this.EditSysName.Type = InputType.Text;
    this.EditSysName.Value = Lookup.sysName;
    this.EditSysName.IsRequired = false;



    let Description=new EnglishArabicDTO();
    Description.Arabic=Lookup.description.arabic;
    Description.English=Lookup.description.english;
    

    this.EditMultiLingualDescription = new MultiLingualTextAreaOptions();
    this.EditMultiLingualDescription.Name = "EditDescription";
    this.EditMultiLingualDescription.ArabicLabelKey =  "DescriptionInArabic";
    this.EditMultiLingualDescription.EnglishLabelKey = "DescriptionInEnglish";
    this.EditMultiLingualDescription.Value = Description;
    
   

    this.EditLookupGroups = new DropdownOptions();
    this.EditLookupGroups.Name = "EditLookupGroups"
    this.EditLookupGroups.LabelKey = "LookupGroups"
    this.EditLookupGroups.DataSource = this.LookupGroupsList
    this.EditLookupGroups.SingleSelection = true;
    this.EditLookupGroups.AllowSearchFilter = true;
    this.EditLookupGroups.Placeholder = "";
    this.EditLookupGroups.SelectedItems = this.LookupGroupsList.filter((item) => { return parseInt(item.key) == Lookup.lookupGroupID; }).map((item) => item.key)[0];;
    this.EditLookupGroups.IsDisabled = this.ProductionMode;

    this.EditIsManageable = new CheckBoxOptions();
    this.EditIsManageable.Name = "EditIsManageable"
    this.EditIsManageable.LabelKey = "Manageable"
    this.EditIsManageable.Value = Lookup.manageable

    this.modalService.open(EditLookupModal);
    this.utilityService.stopBlockUI();

  }
  editLookup() {
    if (this.EditLookupForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.EditLookupForm.value;
      let EditModel = new LookupModel();
      EditModel.ID = Number(this.LookupId);
      EditModel.Name.English = ResultModel.EditName.EnglishValue
      EditModel.Name.Arabic = ResultModel.EditName.ArabicValue
      if (!this.ProductionMode) 
        EditModel.SysName = ResultModel.EditSysName

      EditModel.Description.English = ResultModel.EditDescription.EnglishTextAreaValue
      EditModel.Description.Arabic = ResultModel.EditDescription.ArabicTextAreaValue
      EditModel.LookupGroupID = ResultModel.EditLookupGroups!=null? Number(ResultModel.EditLookupGroups): null
      EditModel.Manageable = ResultModel.EditIsManageable
    
      this.LookupService.EditLookup(EditModel).subscribe((result) => {
        this.modalService.dismissAll();
        let element = this.input as any;
        element.UpdatePaging();
      }, (error) => {

      })
    }
  }
  showDeleteLookupModal(lookup: any, deleteLookupModal) {
    this.utilityService.startBlockUI();
    this.deletedLookupId = lookup.id
    this.modalService.open(deleteLookupModal);
    this.utilityService.stopBlockUI();
  }
  DeleteLookup() {
    this.LookupService.DeleteLookup(this.deletedLookupId).subscribe((result) => {
      this.deletedLookupId = 0;
      this.modalService.dismissAll();
      let element = this.input as any;
      element.ReinitializePaging();
    }, (error) => {
    })

  }
  copyInputMessage() {
    this._clipboardService.copy(this.ValueToCopy.toString());
  }
  showGenerateCodeAllModal(GenerateCodeModal) {
    this.LookupService.GenerateCodeAll().subscribe((result) => {
      var Value = result as any
      this.GenerateCodeTextArea = new TextAreaOptions();
      this.GenerateCodeTextArea.Name = "GenerateCodeTextArea";
      this.GenerateCodeTextArea.Value = Value.val.toString();
      this.ValueToCopy = Value.val.toString();
      this.GenerateCodeTextArea.IsDisabled = true;
      this.GenerateCodeTextArea.HideLabel = true;
      this.GenerateCodeTextArea.Rows = 20;
      this.GenerateCodeTextArea.Cols = 20;
      this.GenerateCodeTextArea.MaxLength = 1000000;
      this.modalService.open(GenerateCodeModal);
    }, (error) => {

    })
  }

  showGenerateApplicationEnumsModal(GenerateCodeModal) {
    this.LookupService.GenerateApplicationEnums().subscribe((result) => {
      var Value = result as any
      this.GenerateCodeTextArea = new TextAreaOptions();
      this.GenerateCodeTextArea.Name = "GenerateCodeTextArea";
      this.GenerateCodeTextArea.Value = Value.val.toString();
      this.ValueToCopy = Value.val.toString();
      this.GenerateCodeTextArea.IsDisabled = true;
      this.GenerateCodeTextArea.HideLabel = true;
      this.GenerateCodeTextArea.Rows = 20;
      this.GenerateCodeTextArea.Cols = 20;
      this.GenerateCodeTextArea.MaxLength = 1000000;
      this.modalService.open(GenerateCodeModal);
    }, (error) => {
     
    })
  }

  showGeneratSysNameModal(GenerateCodeModal) {
    this.LookupService.GenerateSysNames().subscribe((result) => {
      var Value = result as any
      this.GenerateCodeTextArea = new TextAreaOptions();
      this.GenerateCodeTextArea.Name = "GenerateCodeTextArea";
      this.GenerateCodeTextArea.Value = Value.val.toString();
      this.ValueToCopy = Value.val.toString();
      this.GenerateCodeTextArea.IsDisabled = true;
      this.GenerateCodeTextArea.HideLabel = true;
      this.GenerateCodeTextArea.Rows = 20;
      this.GenerateCodeTextArea.Cols = 20;
      this.GenerateCodeTextArea.MaxLength = 1000000;
      this.modalService.open(GenerateCodeModal);
    }, (error) => {
    
    })
  }
  showGenerateCodeByIdModal(template: any, GenerateCodeModal) {
    this.LookupService.GenerateCodeById(template.id).subscribe((result) => {
      var Value = result as any
      this.GenerateCodeTextArea = new TextAreaOptions();
      this.GenerateCodeTextArea.Name = "GenerateCodeTextArea";
      this.GenerateCodeTextArea.Value = Value.val.toString();
      this.ValueToCopy = Value.val.toString();
      this.GenerateCodeTextArea.IsDisabled = true;
      this.GenerateCodeTextArea.HideLabel = true;
      this.GenerateCodeTextArea.Rows = 20;
      this.GenerateCodeTextArea.Cols = 20;
      this.GenerateCodeTextArea.MaxLength = 1000000;
      this.modalService.open(GenerateCodeModal);
     
    }, (error) => {
   
    })
  }




}
